<template>
  <div class="my-4">
    <ValidationObserver ref="tagsForm" tag="form">
      <label class="font-weight-bold">Seleccione Etiqueta(s):</label>
      <div class="row">
        <div class="col-12 col-md-4 border-right">
          <span class="data-title d-block mb-2">
            Etiqueta(s):
          </span>
          <validation-provider v-slot="{ errors }" name="tags" rules="required">
            <custom-drop-down
              v-model="currentTag"
              id="tags"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              custom-error-msg="La etiqueta es requerida."
              :error="errors[0]"
              :options="tagsAvailable"
            />
          </validation-provider>
          <action-button
            id="btn-add-tags"
            type="button"
            text="Añadir"
            i="fas fa-file-plus"
            variant="success"
            class="ml-2 px-4 mb-3 mt-3 float-right actionButton"
            @click="addTags"
          />
        </div>
        <div class="col-12 col-md-8">
          <span class="data-title d-block mb-2">
            Etiqueta(s) Seleccionada(s):
          </span>
          <div
            class="tag-item py-1 px-4 mb-2 mr-2 d-inline-block"
            v-for="(item, index) in model" v-bind:key="index"
          >
            <div class="d-flex">
              <div class="mr-2">
                <span class="font-weight-bold d-block text-nowrap">
                  {{ item.name }}
                </span>
              </div>
              <div class="align-self-center text-center">
                <i
                  class="far fa-times-circle text-red cursor-pointer"
                  @click="removeTags(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
export default {
  name: "TagsSection",
  components: {
    CustomDropDown,
    ActionButton,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      currentTag: null,
      tagsAvailable: [],
    };
  },
  computed: {
    model: {
      get() {
        if (this.value?.length) {
          this.tagsAvailable = this.tagsAvailable.filter(
            e => !this.value.find(x => e.id === x.id) 
          );
        }
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    async addTags() {
      const isValid = await this.$refs.tagsForm.validate();
      if (!isValid) {
        return;
      }
      this.tagsAvailable = this.tagsAvailable.filter(
        e => e.id !== this.currentTag.id
      );
      this.model.push({
        ...this.currentTag
      });
      this.currentTag = null;
      await this.$refs.tagsForm.reset();
    },
    removeTags({ id }) {
      this.model = this.model.filter(e => e.id !== id);
      const option = this.options.find(e => e.id === id);
      this.tagsAvailable.push(option);
    }
  },
  watch: {
    options(val) {
      this.tagsAvailable = [...val];
    },
  }
};
</script>

<style lang="scss" scoped>
.tag-item {
  border-radius: 50px;
  border: 1px solid rgb(220, 220, 220);
  width: fit-content;
  font-size: 90%;
}
.align-self-center {
  align-self: center !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
